let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("12EV3")), load("jLMSV")]).then(() => parcelRequire('lNSe1'));